import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";
import { BfxBlotterOrdersContextMenuAcceptanceState } from "./BfxBlotterOrdersContextMenuAcceptanceState";
import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";
import { BfxBlotterOrdersContextMenuItemAcceptanceState } from "./BfxBlotterOrdersContextMenuItemAcceptanceState";
import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";
import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";
import { ContextMenuState } from "../ContextMenuState";

import { TraderGroupPromiseLookupService } from "../../../lookup/model/impl/TraderGroupPromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class BfxBlotterOrdersContextMenuAcceptanceItem extends BfxBlotterOrdersContextMenuItem {
  private constructor(
    public actionId: BfxBlotterAction,
    _title: string,
    checkAvailable: ContextMenuItemStateCommand<CubiqTS.OrderDataImpl>,
    checkEnabled: ContextMenuItemStateCommand<CubiqTS.OrderDataImpl>,
    public checkAvailableCriteria: ContextMenuItemStateCommandCriteria = ContextMenuItemStateCommandCriteria.MenuItem,
    public checkEnabledCriteria: ContextMenuItemStateCommandCriteria = ContextMenuItemStateCommandCriteria.Item,
  ) {
    super(
      actionId,
      _title,
      checkAvailable,
      checkEnabled,
      checkAvailableCriteria,
      checkEnabledCriteria,
    );
  }

  public reset(): void {
    let oldState = this.state;
    this.state = new BfxBlotterOrdersContextMenuItemAcceptanceState();
    this.state.title = oldState.title;
  }

  static Factory: any = class BfxBlotterOrdersContextMenuAcceptanceItemFactory {
    constructor() {}

    public AcceptOrAcceptTopside(): BfxBlotterOrdersContextMenuAcceptanceItem {
      return new BfxBlotterOrdersContextMenuAcceptanceItem(
        BfxBlotterAction.ACTION_ORDER_ACCEPT,
        "AcceptOrAcceptTopside",
        BfxBlotterOrdersContextMenuAcceptanceItem.checkAcceptAvailableFn(),
        BfxBlotterOrdersContextMenuAcceptanceItem.checkAcceptEnabled(),
        ContextMenuItemStateCommandCriteria.Item,
        ContextMenuItemStateCommandCriteria.PostItem,
      );
    }

    public OptionalAcceptDownside(): BfxBlotterOrdersContextMenuAcceptanceItem {
      return new BfxBlotterOrdersContextMenuAcceptanceItem(
        BfxBlotterAction.ACTION_ORDER_ACCEPT,
        "OptionalAcceptDownside",
        BfxBlotterOrdersContextMenuAcceptanceItem.checkOptionalAcceptDownsideAvailableFn(),
        BfxBlotterOrdersContextMenuAcceptanceItem.checkAcceptEnabled(),
        ContextMenuItemStateCommandCriteria.Item,
        ContextMenuItemStateCommandCriteria.PostItem,
      );
    }

    public AcceptInto(): BfxBlotterOrdersContextMenuAcceptanceItem {
      return new BfxBlotterOrdersContextMenuAcceptanceItem(
        BfxBlotterAction.ACTION_ORDER_ACCEPT_INTO,
        "AcceptInto",
        BfxBlotterOrdersContextMenuAcceptanceItem.checkAcceptIntoAvailableFn(),
        BfxBlotterOrdersContextMenuAcceptanceItem.checkAcceptIntoEnabled(),
        ContextMenuItemStateCommandCriteria.Item,
        ContextMenuItemStateCommandCriteria.PostItem,
      );
    }

    public Seperator(): BfxBlotterOrdersContextMenuAcceptanceItem {
      return new BfxBlotterOrdersContextMenuAcceptanceItem(
        BfxBlotterAction.SEPARATOR,
        "Accept",
        BfxBlotterOrdersContextMenuAcceptanceItem.checkSeperatorAvailableFn(),
        BfxBlotterOrdersContextMenuAcceptanceItem.checkEnabledFalse(),
        ContextMenuItemStateCommandCriteria.Item,
        ContextMenuItemStateCommandCriteria.PostItem,
      );
    }
  };

  private static checkProcessItem(
    menuState: BfxBlotterOrdersContextMenuState,
    itemState: BfxBlotterOrdersContextMenuItemAcceptanceState,
    item?: CubiqTS.OrderDataImpl,
    itemIndex?: number,
  ): void {
    if (itemIndex > menuState.acceptance.processedItemIndex) {
      BfxBlotterOrdersContextMenuAcceptanceItem.processItem(menuState, itemState, item, itemIndex);
      menuState.acceptance.processedItemIndex = itemIndex;
    }
  }

  private static checkAcceptAvailableFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: BfxBlotterOrdersContextMenuItemAcceptanceState,
      item?: CubiqTS.OrderDataImpl,
      itemIndex?: number,
    ) {
      BfxBlotterOrdersContextMenuAcceptanceItem.checkProcessItem(
        menuState,
        itemState,
        item,
        itemIndex,
      );

      itemState.iconClass = "fa icon-check order__menu__menuItem__icon__accept";
      itemState.warnings = menuState.acceptance.warnings;

      if (
        menuState.acceptance.ineligibleItem ||
        menuState.acceptance.ineligibleAccept ||
        menuState.acceptance.hasNoElegible
      ) {
        itemState.title = "Accept Selected";
        itemState.available = false;
      } else if (menuState.acceptance.hasCallOnly) {
        itemState.title = "Accept Topside";
        itemState.callOrderRateSide = CubiqTS.RateSideType.BID;
        itemState.available = true;
      } else if (menuState.acceptance.hasNewPendingOnly) {
        itemState.title = menuState.acceptance.warnings.external.display
          ? "Force Accept"
          : "Accept New";
        itemState.available = true;
      } else if (menuState.acceptance.hasModifyOutOnly) {
        itemState.title = menuState.acceptance.warnings.external.display
          ? "Force Accept"
          : "Accept Modify Out";
        itemState.available = true;
      } else if (menuState.acceptance.hasModifyInOnly) {
        itemState.title = "Accept Modify In";
        itemState.available = true;
      } else if (menuState.acceptance.hasMigrationOnly) {
        itemState.title = "Accept Migration";
        itemState.available = true;
      } else if (menuState.acceptance.hasCancelOnly) {
        itemState.title = menuState.acceptance.warnings.external.display
          ? "Force Accept"
          : "Accept Cancellation";
        itemState.available = true;
      } else if (menuState.acceptance.hasExpiryOnly) {
        itemState.title = "Accept Expiry";
        itemState.available = true;
      } else if (menuState.acceptance.hasTransferOnly) {
        itemState.title = menuState.acceptance.warnings.external.display
          ? "Force Accept Transfer"
          : "Accept Transfer";
        itemState.available = true;
      } else if (menuState.acceptance.hasPauseOnly) {
        itemState.title = "Accept Pause";
        itemState.available = true;
      } else if (menuState.acceptance.hasResumeOnly) {
        itemState.title = "Accept Resume";
        itemState.available = true;
      } else {
        itemState.title = menuState.acceptance.warnings.external.display
          ? "Force Accept"
          : "Accept Selected";
        itemState.available = true;
      }
    };
  }

  private static checkAcceptIntoAvailableFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: BfxBlotterOrdersContextMenuItemAcceptanceState,
      item?: CubiqTS.OrderDataImpl,
      itemIndex?: number,
    ) {
      BfxBlotterOrdersContextMenuAcceptanceItem.checkProcessItem(
        menuState,
        itemState,
        item,
        itemIndex,
      );

      if (menuState.acceptance.hasAcceptIntoElegible && !menuState.acceptance.ineligibleItem) {
        itemState.title = "Accept Into";

        if (menuState.acceptance.hasCallOnly) {
          itemState.queryCallOrderRateSide = true;
        }

        itemState.available = true;
      } else {
        itemState.available = false;
      }
    };
  }

  private static checkSeperatorAvailableFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
      item?: CubiqTS.OrderDataImpl,
      itemIndex?: number,
    ) {
      if (menuState.acceptance.ineligibleItem && menuState.reject.ineligibleItem) {
        itemState.available = false;
      } else {
        itemState.available = true;
      }
    };
  }

  private static checkOptionalAcceptDownsideAvailableFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: BfxBlotterOrdersContextMenuItemAcceptanceState,
      item?: CubiqTS.OrderDataImpl,
      itemIndex?: number,
    ) {
      BfxBlotterOrdersContextMenuAcceptanceItem.checkProcessItem(
        menuState,
        itemState,
        item,
        itemIndex,
      );

      itemState.warnings = menuState.acceptance.warnings;

      if (
        menuState.acceptance.ineligibleItem ||
        menuState.acceptance.ineligibleAccept ||
        menuState.acceptance.hasNoElegible
      ) {
        itemState.available = false;
      } else if (menuState.acceptance.hasCallOnly) {
        itemState.iconClass = "fa icon-check order__menu__menuItem__icon__accept";

        itemState.title = "Accept Downside";
        itemState.callOrderRateSide = CubiqTS.RateSideType.OFFER;
        itemState.available = true;
      } else {
        itemState.available = false;
      }
    };
  }

  private static checkEnabled(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
      item?: CubiqTS.OrderDataImpl,
      itemIndex?: number,
    ) {
      itemState.enabled = menuState.acceptance.ineligibleItem === false;
    };
  }

  private static checkAcceptEnabled(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: BfxBlotterOrdersContextMenuItemAcceptanceState,
      item?: CubiqTS.OrderDataImpl,
      itemIndex?: number,
    ) {
      if (menuState.acceptance.ineligibleItem === false) {
        itemState.enabled = true;
        // share state for event firing
        itemState.actionRequests = menuState.acceptance.actionRequests;
      }
    };
  }

  private static checkAcceptIntoEnabled(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: BfxBlotterOrdersContextMenuItemAcceptanceState,
      item?: CubiqTS.OrderDataImpl,
      itemIndex?: number,
    ) {
      if (menuState.acceptance.ineligibleItem === false) {
        itemState.enabled = true;
        // share state for event firing
        itemState.actionRequests = menuState.acceptance.actionRequests;
      }
    };
  }

  private static checkEnabledFalse(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
      item?: CubiqTS.OrderDataImpl,
    ) {
      itemState.enabled = false;
    };
  }

  private static processItem(
    menuState: BfxBlotterOrdersContextMenuState,
    itemState: BfxBlotterOrdersContextMenuItemAcceptanceState,
    item?: CubiqTS.OrderDataImpl,
    itemIndex?: number,
  ) {
    // break early if we can
    if (item == null || menuState.acceptance.ineligibleItem) {
      return;
    }

    let isAcceptanceItem: boolean = false;
    let isProcessedStrategyItem: boolean = false;

    let isTrader: boolean = CubiqTS.UserType.TRADER === menuState.activeUser.userTypeId;

    // Little function to determine if a group ID represents an external trader group
    const isExternal = (groupId, groupMap: Map<string, CubiqTS.TradingGroupImpl>) => {
      if (groupId != null) {
        const group = groupMap.get(groupId.toString());
        return group?.isExternallyFilledFg ?? false;
      }
      return false;
    };

    const isItemTraderGroupExternal = isExternal(item.deskId, menuState.traderGroups);
    const isItemTargetGroupExternal = isExternal(item.targetDeskId, menuState.traderGroups);

    // Permitted only for a trader with accept role or any user with unrestricted role
    const isTransfer: boolean = !!item.targetDeskId && !!item.transferUserId;
    const permitted: boolean =
      (menuState.canAccept && isTrader) || menuState.canAcceptUnrestricted || isTransfer;
    let inPauseResumePending: boolean = false;

    if (permitted) {
      const isTraderInGroup =
        CubiqTS.UserType.TRADER === menuState.activeUser.userTypeId &&
        item.deskId != null &&
        menuState.activeUser.tradingGroupsIdSet.has(item.deskId.toString());
      const isTraderAndUnrestricted =
        CubiqTS.UserType.TRADER === menuState.activeUser.userTypeId &&
        menuState.canAcceptUnrestricted;
      const isUnrestricted = menuState.canAcceptUnrestricted;
      const isDefaultTraderGroup = item.deskId != null && "-1" === item.deskId.toString();

      if (
        item.strategyId &&
        menuState.acceptance.processedSiblingStrategyIds.has(item.strategyId.toString())
      ) {
        // accept only on leg of strategy
        isProcessedStrategyItem = true;
      } else if (
        (CubiqTS.OrderState.ACCEPTANCE_NEEDED === item.orderState ||
          CubiqTS.OrderState.EXT_ACCEPTANCE_NEEDED === item.orderState) &&
        // in my trader groups or unrestricted
        (isTraderInGroup || menuState.canAcceptUnrestricted)
      ) {
        // TODO Add Errors handling too
        let requiresCallOrderRateSide =
          CubiqTS.RequestOrderType.CALL === item.requestedOrderType &&
          CubiqTS.RateSideType.BID !== item.trackingSide &&
          CubiqTS.RateSideType.OFFER !== item.trackingSide;

        if (CubiqTS.LockType.MODIFY_LOCK === item.lockType) {
          if (requiresCallOrderRateSide) {
            menuState.acceptance.callCount++;
          } else {
            menuState.acceptance.modifyInCount++;
          }
          if ((isTraderInGroup || isTraderAndUnrestricted) && !isItemTraderGroupExternal) {
            menuState.acceptance.acceptIntoElegible++;
            menuState.acceptance.addAcceptIntoRequest(
              CubiqTS.AcceptanceType.ENTRY,
              item.orderId.toString(),
            );
          }

          if (isDefaultTraderGroup) {
            menuState.acceptance.ineligibleAccept = true;
          } else {
            menuState.acceptance.addAcceptRequest(
              CubiqTS.AcceptanceType.ENTRY,
              item.orderId.toString(),
            );
          }
        } else {
          if (requiresCallOrderRateSide) {
            menuState.acceptance.callCount++;
          } else {
            menuState.acceptance.newPendingCount++;
          }
          if ((isTraderInGroup || isTraderAndUnrestricted) && !isItemTraderGroupExternal) {
            menuState.acceptance.acceptIntoElegible++;
            menuState.acceptance.addAcceptIntoRequest(
              CubiqTS.AcceptanceType.ENTRY,
              item.orderId.toString(),
            );
          }
          if (isDefaultTraderGroup) {
            menuState.acceptance.ineligibleAccept = true;
          } else {
            menuState.acceptance.addAcceptRequest(
              CubiqTS.AcceptanceType.ENTRY,
              item.orderId.toString(),
            );
          }
        }

        isAcceptanceItem = true;
      } else if (
        CubiqTS.LockType.PAUSE_LOCK == item.lockType &&
        CubiqTS.PauseState.PAUSE_PENDING == item.pauseState &&
        (isTraderInGroup || menuState.canAcceptUnrestricted)
      ) {
        menuState.acceptance.pauseCount++;
        menuState.acceptance.addAcceptRequest(
          CubiqTS.AcceptanceType.PAUSE,
          item.orderId.toString(),
        );
        isAcceptanceItem = true;
        inPauseResumePending = true;
      } else if (
        CubiqTS.LockType.PAUSE_LOCK == item.lockType &&
        CubiqTS.PauseState.RESUME_PENDING == item.pauseState &&
        (isTraderInGroup || menuState.canAcceptUnrestricted)
      ) {
        menuState.acceptance.resumeCount++;
        menuState.acceptance.addAcceptRequest(
          CubiqTS.AcceptanceType.RESUME,
          item.orderId.toString(),
        );
        isAcceptanceItem = true;
        inPauseResumePending = true;
      } else if (
        (CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED === item.orderState ||
          CubiqTS.OrderState.EXT_MODIFY_ACCEPTANCE_NEEDED === item.orderState) &&
        (isTraderInGroup || menuState.canAcceptUnrestricted)
      ) {
        menuState.acceptance.modifyOutCount++;
        menuState.acceptance.addAcceptRequest(
          CubiqTS.AcceptanceType.MODIFICATION,
          item.orderId.toString(),
        );
        isAcceptanceItem = true;
      } else if (
        (CubiqTS.OrderState.CANCEL_ACCEPTANCE_NEEDED === item.orderState ||
          CubiqTS.OrderState.EXT_CANCEL_ACCEPTANCE_NEEDED === item.orderState) &&
        // user rules
        (isTraderInGroup || menuState.canAcceptUnrestricted)
      ) {
        menuState.acceptance.cancelCount++;
        menuState.acceptance.addAcceptRequest(
          CubiqTS.AcceptanceType.CANCEL,
          item.orderId.toString(),
        );
        isAcceptanceItem = true;
      } else if (
        (CubiqTS.OrderState.EXPIRY_ACCEPTANCE_NEEDED === item.orderState ||
          CubiqTS.OrderState.TRIGGERED_EXPIRY_ACCEPTANCE_NEEDED === item.orderState) && // user rules
        (isTraderInGroup || menuState.canAcceptUnrestricted)
      ) {
        menuState.acceptance.expiryCount++;
        menuState.acceptance.addAcceptRequest(
          CubiqTS.AcceptanceType.EXPIRY,
          item.orderId.toString(),
        );

        isAcceptanceItem = true;
      } else if (CubiqTS.OrderState.MIGRATION_ACCEPTANCE_NEEDED === item.orderState) {
        let traderInTargetGroup =
          !!item.targetDeskId &&
          menuState.activeUser.tradingGroupsIdSet.has(item.targetDeskId.toString());

        if (isDefaultTraderGroup) {
          menuState.acceptance.acceptIntoElegible++;
          menuState.acceptance.addAcceptIntoRequest(
            CubiqTS.AcceptanceType.ENTRY,
            item.orderId.toString(),
          );

          // not enough information for Accept & Reject not permitted
          // note this is distinct from an ineligibleItem
          menuState.acceptance.ineligibleAccept = true;
          isAcceptanceItem = true;
        } else if ((isTraderInGroup || isUnrestricted) && !isItemTraderGroupExternal) {
          if (isTraderAndUnrestricted) {
            menuState.acceptance.acceptIntoElegible++;
            menuState.acceptance.addAcceptIntoRequest(
              CubiqTS.AcceptanceType.ENTRY,
              item.orderId.toString(),
            );
          }

          menuState.acceptance.addAcceptRequest(
            CubiqTS.AcceptanceType.ENTRY,
            item.orderId.toString(),
          );
          menuState.acceptance.migrationCount++;

          isAcceptanceItem = true;
        }
      } else if (!!item.targetDeskId && !!item.transferUserId) {
        // FIXME: why is mediator ActiveUser object using number for trading group ids?
        let traderInTargetGroup = menuState.activeUser.tradingGroupsIdSet.has(
          item.targetDeskId.toString(),
        );
        const transferExternal = isItemTraderGroupExternal || isItemTargetGroupExternal;
        const canExternalAction =
          transferExternal &&
          menuState.canTransferAccept &&
          (menuState.canAccept || menuState.canAcceptUnrestricted);
        const canInternalAction = !transferExternal && menuState.canTransferAccept;
        // FXBFXOM-10530: Trader can accept if has DI_TRADER_TRANSFER and either in group or has TRADER_UNRESTRICTED

        if (
          (traderInTargetGroup || menuState.canAcceptUnrestricted) &&
          (canExternalAction || canInternalAction)
        ) {
          menuState.acceptance.addXferAcceptRequest(
            item.targetDeskId.toString(),
            item.orderId.toString(),
          );
          menuState.acceptance.transferCount++;

          if (!isItemTraderGroupExternal && !isItemTargetGroupExternal) {
            // Cannot Accept Into with an order that is stuck in external transfer
            menuState.acceptance.acceptIntoElegible++;
            menuState.acceptance.addXferAcceptIntoRequest(
              item.targetDeskId.toString(),
              item.orderId.toString(),
            );
          }

          isAcceptanceItem = true;
        } else {
          isAcceptanceItem = false;
        }
      }
    }

    if (isAcceptanceItem) {
      menuState.acceptance.count++;

      // item is with external trader group
      if (
        (isItemTraderGroupExternal &&
          (CubiqTS.OrderState.EXT_ACCEPTANCE_NEEDED === item.orderState ||
            CubiqTS.OrderState.EXT_CANCEL_ACCEPTANCE_NEEDED === item.orderState ||
            CubiqTS.OrderState.EXT_MODIFY_ACCEPTANCE_NEEDED === item.orderState ||
            inPauseResumePending)) ||
        (isTransfer && (isItemTraderGroupExternal || isItemTargetGroupExternal))
      ) {
        menuState.acceptance.warnings.show = true;
        menuState.acceptance.warnings.external.display = true;
        menuState.acceptance.warnings.external.ids.push(item.orderId.toString());
        menuState.acceptance.warnings.external.orderRefs.push(item.orderRef);
      }
      if (item.strategyId != null) {
        // && item.siblingRelationship &&
        // CubiqTS.OrderRelationshipType.OCO === item.siblingRelationship.relationshipType ) {
        menuState.acceptance.processedSiblingStrategyIds.add(item.strategyId.toString());
      }
    } else if (isProcessedStrategyItem) {
      // no impact on counts
    } else {
      menuState.acceptance.ineligibleItem = true;
    }
  }

  public static get state(): any {
    return new BfxBlotterOrdersContextMenuAcceptanceState();
  }
}
